function cardTypeRequiresCvv(cardType) {
    return String(cardType || 'credit') === 'credit';
}

export {
    cardTypeRequiresCvv,
};
